export default __webpack_public_path__ + "static/media/Trends (1).88882ece.svg";